/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prescription_Days_Out_Of_RangeInputs */

const en_us2_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your week has a number of days we cannot build a split for. Change your training days and try again.`)
};

const pt_br2_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua semana tem uma quantidade de dias para a qual não conseguimos montar uma divisão. Mude seus dias de treino e tente de novo.`)
};

const es_419_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu semana tiene una cantidad de días para la que no podemos armar una división. Cambia tus días de entrenamiento e intenta de nuevo.`)
};

const pt_pt2_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua semana tem um número de dias para o qual não conseguimos montar uma divisão. Muda os teus dias de treino e tenta outra vez.`)
};

const fr_fr2_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta semaine a un nombre de jours pour lequel on ne peut pas créer de répartition. Modifie tes jours d'entraînement et réessaie.`)
};

const de_de2_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für die Anzahl an Tagen in deiner Woche können wir keinen Split erstellen. Ändere deine Trainingstage und versuch es noch mal.`)
};

const it_it2_prescription_days_out_of_range = /** @type {(inputs: Prescription_Days_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua settimana ha un numero di giorni per cui non riusciamo a creare uno split. Cambia i tuoi giorni di allenamento e riprova.`)
};

/**
* | output |
* | --- |
* | "Your week has a number of days we cannot build a split for. Change your training days and try again." |
*
* @param {Prescription_Days_Out_Of_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_days_out_of_range = /** @type {((inputs?: Prescription_Days_Out_Of_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Days_Out_Of_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_days_out_of_range(inputs)
	if (locale === "es-419") return es_419_prescription_days_out_of_range(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_days_out_of_range(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_days_out_of_range(inputs)
	if (locale === "de-DE") return de_de2_prescription_days_out_of_range(inputs)
	if (locale === "it-IT") return it_it2_prescription_days_out_of_range(inputs)
	return en_us2_prescription_days_out_of_range(inputs)
});
export { prescription_days_out_of_range as "prescription.days_out_of_range" }